import React from 'react';
import { CollectionListProductItem } from './CollectionListProductItem';
import { Box, styled } from '@mui/material';
import { ProductSearch } from '../../../models/ProductSearch';

const CollectionItemWrapper = styled(Box)(() => ({
    paddingBottom: '10px',
}));

export const CollectionListWrapper = (props: {
    products: ProductSearch[];
    handle: string;
}) => {
    const { products, handle } = props;

    return (
        <Box>
            {products.map((item) => {
                return (
                    <CollectionItemWrapper key={item.id}>
                        <CollectionListProductItem
                            product={item}
                            handle={handle}
                        />
                    </CollectionItemWrapper>
                );
            })}
        </Box>
    );
};
